import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/orgs/$orgId/apiKeys')({
  loader: () => ({
    crumb: 'API Keys',
  }),
})
